import React from 'react';
import PropTypes from 'prop-types';
import { NextButton, PrevButton, RestartButton } from '../buttons/buttons.js';
import { EmailLink } from '../emaillink/emaillink.component';
import './footer.scss';
import classNames from 'classnames';

const Footer = props => {
    const {
            showNext,
            next,
            showPrev,
            restart,
            showRestart,
            prev,
            email,
            showError,
            errorMessage,
            idPrefix,
            prevActionName,
            nextActionName,
            emailActionName,
            emailProgressLinkSupText
        } = props,
        classes = classNames(`ht-footer--${idPrefix}`, {
            'ht-footer': true
        });

    return (
        <div className={classes}>
            {showError && errorMessage && (
                <div className='ht-footer-error'>
                    <p dangerouslySetInnerHTML={{ __html: errorMessage }} />
                </div>
            )}
            <div className='ht-footer-actions'>
                <div className='ht-footer-actions-left'>
                    {prev && showPrev && (
                        <PrevButton
                            {...prev}
                            id={`${idPrefix}-footer-previous`}
                            prevActionName={prevActionName}
                        />
                    )}
                </div>
                <div className='ht-footer-actions-right'>
                    {next && showNext && (
                        <NextButton
                            {...next}
                            id={`${idPrefix}-footer-next`}
                            nextActionName={nextActionName}
                        />
                    )}
                    {restart && showRestart && (
                        <RestartButton
                            {...restart}
                            id={`${idPrefix}-footer-restart`}
                        />
                    )}
                </div>
                <div className='ht-footer-actions-bottom'>
                    { email && emailProgressLinkSupText &&
                        <p className='ht-footer-actions-bottom-content'>
                            { emailProgressLinkSupText }
                        </p> }
                    {email && (
                        <EmailLink
                            {...email}
                            id={`${idPrefix}-footer-email`}
                            emailActionName={emailActionName}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

Footer.defaultProps = {
    showNext: true,
    showPrev: true,
    showRestart: true,
    showError: false,
    errorMessage: false,
    email: false
};

Footer.propTypes = {
    idPrefix: PropTypes.string.isRequired,
    showNext: PropTypes.bool,
    showPrev: PropTypes.bool,
    showEmail: PropTypes.bool,
    showRestart: PropTypes.bool,
    showError: PropTypes.bool,
    next: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
    prev: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
    email: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
    restart: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
    errorMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
};

export default Footer;
